import { DomainFilterCard } from './DomainFilterCard';
import { FilterGroupRenderer } from './FilterGroupRenderer';
import { TemporalGroupRenderer } from './TemporalGroupRenderer';
import {
  type LogicNode,
  isDomainFilter,
  isFilterGroup,
  isTemporalGroup,
} from '../../utils/analyticalVariable.utils';

interface LogicNodeRendererProps {
  node: LogicNode;
  onChipClick: (name: string) => void;
  isCorrelatedFilter?: boolean;
}

export const LogicNodeRenderer = ({
  node,
  onChipClick,
  isCorrelatedFilter = false,
}: LogicNodeRendererProps) => {
  if (isDomainFilter(node)) {
    return (
      <DomainFilterCard
        filter={node}
        onChipClick={onChipClick}
        isCorrelatedFilter={isCorrelatedFilter}
      />
    );
  }

  if (isFilterGroup(node)) {
    return <FilterGroupRenderer group={node} onChipClick={onChipClick} />;
  }

  if (isTemporalGroup(node)) {
    return <TemporalGroupRenderer group={node} onChipClick={onChipClick} />;
  }

  if (process.env.NODE_ENV !== 'production') {
    console.warn('LogicNodeRenderer: unrecognised node type', node);
  }
  return null;
};
